/* =============================================================
 *  INFINAGON RECORDINGS — SHOP PRODUCTS CONFIG
 * =============================================================
 *
 *  ALL products live here. The Shop page reads from this file.
 *
 *  PAYPAL CHECKOUT
 *  ---------------
 *  Each product can ship with EITHER:
 *
 *  (A) A "Buy Now" PayPal hosted button   ← most polished UX
 *      paypalButtonId: "ABCD1234EFGHJ"
 *      → Get this from PayPal:
 *          1. Log in → Pay & Get Paid → Buttons → Create New Button
 *          2. Pick "Buy Now", set price/SKU/shipping
 *          3. Copy the value of `hosted_button_id` and paste it here.
 *
 *  (B) A direct PayPal.me checkout link   ← fastest, no setup
 *      paypalMeUrl: "https://paypal.me/yourhandle/25"
 *
 *  (C) Leave both blank AND set `comingSoon: true` to render as
 *      "Coming Soon" placeholder.
 *
 *  HOW TO ADD A NEW ITEM
 *  ---------------------
 *  Each category section below has a clearly-marked, commented-out
 *  TEMPLATE block. Copy the block, paste it just below the
 *  template (still inside the array), uncomment it (remove the
 *  leading "// " on each line), then fill in the values. Save
 *  the file — the Shop page picks it up automatically.
 *
 *  NOTE: Comments in this file are invisible to website visitors.
 *  They only show up here in the source code.
 * ============================================================= */

// Owner's PayPal account details — used as the fallback merchant
// identifier when a product doesn't specify its own button or link.
export const PAYPAL_EMAIL = "datboisheed@gmail.com";
export const PAYPAL_MERCHANT_ID = "M2ZZKR2VRD782";

export const shopProducts = [

  // ═══════════════════════════════════════════════════════════
  // ── MERCH ──────────────────────────────────────────────────
  // ═══════════════════════════════════════════════════════════
  //
  // TEMPLATE — copy the block between the markers below, paste
  // it inside the MERCH section, then fill in the fields.
  //
  // ──────────────── MERCH TEMPLATE  ▼ ────────────────────────
  // {
  //   id: "unique-slug-here",          // kebab-case unique id
  //   category: "Merch",
  //   title: "Product Name",
  //   price: 35.00,                    // USD; null if no price yet
  //   description: "Short blurb shown under the title.",
  //   image: "/assets/your-image.png", // local /assets/... or full https URL
  //   paypalButtonId: "",              // hosted_button_id (option A)
  //   paypalMeUrl: "",                 // paypal.me link    (option B)
  //   soldOut: false,
  //   comingSoon: false,               // true = render as Coming Soon
  // },
  // ──────────────── MERCH TEMPLATE  ▲ ────────────────────────
  //
  {
    id: "merch-placeholder",
    category: "Merch",
    title: "Merch · Dropping Soon",
    price: null,
    description:
      "Studio-branded tees, crewnecks and caps. Limited drops, built to last.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/4a603d01-0faa-424b-8809-2e2a434a464d/images/76662efcbe26e27368f2f26deae429680a277ef89ba4895a83bf1c919d6fd643.png",
    paypalButtonId: "",
    paypalMeUrl: "",
    soldOut: false,
    comingSoon: true,
  },

  // ═══════════════════════════════════════════════════════════
  // ── MUSIC ──────────────────────────────────────────────────
  // ═══════════════════════════════════════════════════════════
  //
  // TEMPLATE — copy the block between the markers below, paste
  // it inside the MUSIC section, then fill in the fields.
  //
  // ──────────────── MUSIC TEMPLATE  ▼ ────────────────────────
  // {
  //   id: "artist-trackname",          // kebab-case unique id
  //   category: "Music",
  //   title: "Artist — Track Name",
  //   price: 10.00,                    // USD
  //   description: "Single · Digital download. Credits & notes.",
  //   image: "/assets/cover-art.png",  // local /assets/... or full https URL
  //   paypalButtonId: "HOSTEDBTNID",   // PayPal hosted_button_id
  //   paypalMeUrl: "",
  //   soldOut: false,
  //   comingSoon: false,
  // },
  // ──────────────── MUSIC TEMPLATE  ▲ ────────────────────────
  //
  {
    id: "grns-ludus-red-suvs",
    category: "Music",
    title: "grns — Ludus [Red SUVs]",
    price: 10.0,
    description:
      "Single · Digital download. Produced, mixed & mastered at Infinagon Recordings.",
    image: "/assets/grns-ludus.png",
    paypalButtonId: "M5ST3XHYHLB32",
    paypalMeUrl: "",
    soldOut: false,
    comingSoon: false,
  },
  {
    id: "grns-okay-it-factor",
    category: "Music",
    title: "grns — Okay (It Factor)",
    price: 10.0,
    description:
      "Single · Digital download. Produced, mixed & mastered at Infinagon Recordings.",
    image: "/assets/grns-okay.png",
    paypalButtonId: "LFGG8EERK9VKS",
    paypalMeUrl: "",
    soldOut: false,
    comingSoon: false,
  },
  {
    id: "grns-liberation",
    category: "Music",
    title: "grns — Liberation",
    price: 25.0,
    description:
      "Single · Digital download. Produced, mixed & mastered at Infinagon Recordings.",
    image: "/assets/grns-liberation.jpg",
    paypalButtonId: "MPWGMDDG2Z7DQ",
    paypalMeUrl: "",
    soldOut: false,
    comingSoon: false,
  },

  // ═══════════════════════════════════════════════════════════
  // ── DIGITAL ────────────────────────────────────────────────
  // ═══════════════════════════════════════════════════════════
  //
  // TEMPLATE — copy the block between the markers below, paste
  // it inside the DIGITAL section, then fill in the fields.
  //
  // ──────────────── DIGITAL TEMPLATE  ▼ ──────────────────────
  // {
  //   id: "unique-slug-here",          // kebab-case unique id
  //   category: "Digital",
  //   title: "Product Name (PDF / Preset / Sample Pack)",
  //   price: 19.00,                    // USD
  //   description: "Instant download. What's inside.",
  //   image: "/assets/digital-cover.png",
  //   paypalButtonId: "",
  //   paypalMeUrl: "",
  //   soldOut: false,
  //   comingSoon: false,
  // },
  // ──────────────── DIGITAL TEMPLATE  ▲ ──────────────────────
  //
  {
    id: "digital-placeholder",
    category: "Digital",
    title: "Digital Products · Coming Soon",
    price: null,
    description:
      "Preset packs, sample libraries, drum kits and mix templates. Instant downloads.",
    image:
      "https://images.unsplash.com/photo-1556569482-a1813394ef9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHx2aW55bCUyMHJlY29yZCUyMG11c2ljJTIwcHJvZHVjdGlvbnxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzgwNTA5Njd8MA&ixlib=rb-4.1.0&q=85",
    paypalButtonId: "",
    paypalMeUrl: "",
    soldOut: false,
    comingSoon: true,
  },

];

export default shopProducts;
